/* eslint-disable import/no-anonymous-default-export */
import apiInstance from "./axiosConfig";

export default {
  GET: async (link) => {
    let { data } = await apiInstance.get(link);
    return data;
  },

 
  DOWNLOAD: async (link) => {
    let response = await apiInstance.get(link, { responseType: "blob" });
    return response;
  },

  POST: async (link, apiData) => {
    let { data } = await apiInstance.post(link, apiData);
    return data;
  },

  PUT: async (link, apiData) => {
    let { data } = await apiInstance.put(link, apiData);
    return data;
  },

  PATCH: async (link, apiData) => {
    let { data } = await apiInstance.patch(link, apiData);
    return data;
  },

  DELETE: async (link) => {
    let { data } = await apiInstance.delete(link);
    return data;
  },

  DELETE_WITH_BODY: async (link, apiData) => {
    let { data } = await apiInstance.delete(link, { data: apiData });
    return data;
  },

  FILE_UPLOAD: async (link, apiData) => {
    let formData = new FormData();

    for (var key in apiData) {
      if (apiData.hasOwnProperty(key)) {
        if (key === "files") {
          for (let i = 0; i < apiData[key].length; i++) {
            const file = apiData[key][i];
            formData.append(key, file);
          }
        }
        formData.append(key, apiData[key]);
      }
    }

    let { data } = await apiInstance.post(link, formData);
    return data;
  },

  GET_BLOB: async (link) => {
    let response = await apiInstance.get(link, { responseType: "blob" });
    let filename = "sanaam"
    const disposition = response.headers["Content-Disposition"];

    if (disposition && disposition.includes("filename=")) {
      console.log(disposition)
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match?.[1]) {
        filename = match[1];
      }
    }

    const contentType = response.headers["content-type"];
    let extension = "";
    if (contentType === "application/csv" || contentType === "text/csv") {
      extension = ".csv";
    } else if (contentType === "application/pdf") {
      extension = ".pdf";
    } else if (contentType === "application/zip") {
      extension = ".zip";
    }

    // If filename has no extension, add one
    if (!filename.includes(".")) {
      filename += extension;
    }

    // Create Blob and trigger download
    const blob = new Blob([response.data], { type: contentType });
    const url = window.URL.createObjectURL(blob);
    const ll = document.createElement("a");
    ll.href = url;
    ll.download = filename;
    document.body.appendChild(ll);
    ll.click();

    // Cleanup
    window.URL.revokeObjectURL(url);
    document.body.removeChild(ll);

    return response.data
  },
  async formPUT(link, apiData) {
    console.log(apiData);
    let formData = this.buildFormData(apiData);
    console.log(formData);
    let { data } = await apiInstance.put(link, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  async formPATCH(link, apiData) {
    let formData = this.buildFormData(apiData);
    let { data } = await apiInstance.patch(link, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  },
  buildFormData(payload) {
    const formData = new FormData();

    Object.entries(payload).forEach(([key, value]) => {
      // Boolean → "on" / "off"
      if (typeof value === "boolean") {
        formData.append(key, value ? "on" : "off");
      }

      // Files
      else if (value instanceof File) {
        formData.append(key, value);
      } else if (Array.isArray(value)) {
        for (let i = 0; i < value.length; i++) {
          formData.append(`${key}[${i}]`, typeof value[i] === "object" ? JSON.stringify(value[i]) : value[i]);
        }
      }

      // Objects (but NOT File)
      else if (
        (typeof value === "object" && value !== null)
      ) {
        formData.append(key, JSON.stringify(value));
      }

      // Primitives
      else if (value !== undefined && value !== null) {
        formData.append(key, String(value));
      }
    });

    return formData;
  }

};
